import React, { useContext, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useHistory } from "react-router-dom";
import LoadingAnimation from '../loading-animation';
import ReviewSelector from '../review-selector/';
import UserSelector from '../user-selector/';
import { UserContext } from "../../providers/user-provider";
import InputField from "../input-field"
import { getPendingAlbums, getRecentUserReviews } from "../../api/";
import { updateMetadata } from "../../firebase";
import * as Actions from '../../redux/actions/';
import './admin-home.scss';
import pma from '../../images/disappointedPMA.jpg';

const AdminHome = ({ impersonationUser, setImpersonationUser }) => {
	const [isLoading, setIsLoading] = useState(true);
	const [recentReviews, setRecentReviews] = useState([]);
	const [pendingReviews, setPendingReviews] = useState([]);
	const [imageFileName, setImageFileName] = useState('');
	const user = useContext(UserContext);
	let history = useHistory();

	useEffect(() => {
		async function getPageData() {
			const recentReviewData = await getRecentUserReviews(user.id);
			const mappedRecentReviews = recentReviewData.map(album => {
				return {
					id: album.id,
					album: album.name,
					artist: album.artist.name,
					status: album.reviews[user.id].status
				}
			});
			if (user.role === 'owner') {
				const pendingReviewData = await getPendingAlbums();
				const mappedPendingReviews = pendingReviewData.reduce((accumulator, thisAlbum) => {
					Object.values(thisAlbum.reviews).forEach(thisReview => {
						if (thisReview.status === 'pending') {
							let mergedReview = {
								id: thisAlbum.id,
								album:  thisAlbum.name,
								artist: thisAlbum.artist.name,
								author: thisReview.author,
								reviewDate: thisReview.reviewDate,
								status: thisReview.status
							};
							accumulator.push(mergedReview);
						}
					});

					return accumulator;
				}, []);
				setPendingReviews(mappedPendingReviews);
			}
			setRecentReviews(mappedRecentReviews);
			setIsLoading(false);
		}
		getPageData();
	}, [user.id, user.role]);

	function handleReviewClick (id) {
		history.push(`/albums/${id}?edit-review=true`);
	}
	function handleReviewApproveClick (id) {
		history.push(`/albums/${id}`);
	}
	function handleAddFeatureClick () {
		history.push(`/add-feature`);
	}
	function handleAddReviewClick () {
		history.push(`/add-review`);
	}

	function handleUserSelected (val) {
		setImpersonationUser(typeof val === 'object' ? val : null);
	}

	function getWelcomeMessage () {
		const randomNum = Math.floor(Math.random() * 10) + 1;

		switch (randomNum) {
			case 1:
				return 'It’s been a while. Since I saw you the last time. And it feels like I never will again.';
			case 2:
				return 'It\'s your turn to be burnt on a stick.';
			case 3:
				return 'Surrounded by tragical memories. That pushes me out of the too small bed.';
			case 4:
				return 'Compared to how you used to feel, I\'d say that you feel better.';
			case 5:
				return 'Never burning the other one’s heart on a stick and just throwing it to waste.';
			case 6:
				return 'I told your face it looked like hell. You slapped me red and ran away.';
			case 7:
				return 'Would anybody miss me if I went away for a couple of days? Would I miss myself too much?';
			case 8:
				return 'How long have you wanted to beat me up? Well I appreciate if you don’t act like me.';
			case 9:
				return 'If you travelled this far to spit me in my face, I must really deserve you calling me a fake.';
			default:
				return 'You can say so many evil things. Well everybody do...'
		}

	}

	// TODO: map recentReviews and get the status of this user's review
	return (
		<>
		{isLoading && <LoadingAnimation text="One moment, please..." showMask /> }
		<div className="page admin-home">
			<div className="page-content">
				<h1>Firesideometer Admin</h1>
				<p className="welcome-message">{getWelcomeMessage()}</p>
				{user.role === 'owner' &&
					<>
					{pendingReviews.length > 0 &&
						<ReviewSelector
							reviews={pendingReviews}
							onReviewClick={handleReviewApproveClick}
							label="Awaiting Your Approval"
							showAuthor
						/>
					}
					<UserSelector
						label="Impersonate User"
						onSelect={handleUserSelected}
						onDeselect={handleUserSelected}
						userData={impersonationUser}
						zIndex="2"
					/>
					</>
				}
				{recentReviews.length ?
					<ReviewSelector
						reviews={recentReviews}
						onReviewClick={handleReviewClick}
						label="Your Recent Reviews"
					/> :
					(<p>
						{ !(isLoading || pendingReviews.length) && <img src={pma} className="disappointedPMA" alt="" />}
						You haven't written any reviews yet. WTF, dude.
					</p>)
				} {
					user.role === 'owner' &&
					<div>
						<InputField
							id="setmetadata"
							label="Set Image Metadata"
							value={imageFileName || ''}
							onChange={(evt) => {
								setImageFileName(evt.target.value);
							}}
						/>
						<button onClick={() => {
							updateMetadata(imageFileName);
						}}>Update Metadata</button>
					</div>
				}
				<div className="home-actions">
					<button className="secondary" onClick={handleAddFeatureClick}>Add a New Feature</button>
					<button className="primary" onClick={handleAddReviewClick}>Add a New Review</button>
				</div>
			</div>
		</div>
		</>
	)
};

AdminHome.propTypes = {
	impersonationUser: PropTypes.object,
	setImpersonationUser: PropTypes.func
};

const mapStateToProps = state => {
	return {
		impersonationUser: state.impersonationUser
  }
}

const mapDispatchToProps = {
	setImpersonationUser: Actions.setImpersonationUser
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminHome);
